import type { AnchorHTMLAttributes } from "react";

import { className as classNameHelper } from "../utilities/className";

import * as styles from "./ButtonLink.module.scss";

export interface ButtonLinkProps extends Omit<
	AnchorHTMLAttributes<HTMLAnchorElement>,
	"target" | "rel"
> {
	href: string;
	kind: "primary" | "secondary";
	size: "sm" | "lg";
	openInNewTab?: boolean;
}

export function ButtonLink({
	kind,
	size,
	openInNewTab,
	className,
	children,
	...props
}: ButtonLinkProps): JSX.Element {
	return (
		<a
			{...props}
			{...(openInNewTab ? { target: "_blank", rel: "noopener" } : {})}
			{...classNameHelper(styles["button-link"], className)}
			data-kind={kind}
			data-size={size}
		>
			<span className={styles["button-link__label"]}>{children}</span>
		</a>
	);
}
